import {
  ROLE_ADMIN,
  ROLE_B2C,
  ROLE_LOGISTICS,
  ROLE_PARTNER_ADMIN,
  ROLE_PARTNER_READ_ONLY,
  ROLE_POST_SALES,
  ROLE_READ_ONLY,
  ROLE_SUPER_ADMIN,
} from 'auth'

export const USERS_LIST_TYPE_ARVAL_USERS = 'arvalUsers'
export const USERS_LIST_TYPE_PARTNERS = 'partners'
export const USERS_LIST_TYPE_PARTNER_USERS = 'partnerUsers'

export const USERS_ACCOUNT_TYPE_ARVAL_USERS_LIST = [
  ROLE_SUPER_ADMIN,
  ROLE_ADMIN,
  ROLE_READ_ONLY,
  ROLE_LOGISTICS,
  ROLE_B2C,
  ROLE_POST_SALES,
]

export const USERS_ACCOUNT_TYPE_PARTNER_USERS_LIST = [
  ROLE_PARTNER_ADMIN,
  ROLE_PARTNER_READ_ONLY,
]

export const USERS_STATE_ENABLED = 'enabled'
export const USERS_STATE_DISABLED = 'disabled'

export const USERS_STATES_LIST = [USERS_STATE_ENABLED, USERS_STATE_DISABLED]

export const getUsersTypeList = (listType) =>
  listType === USERS_LIST_TYPE_ARVAL_USERS
    ? USERS_ACCOUNT_TYPE_ARVAL_USERS_LIST
    : listType === USERS_LIST_TYPE_PARTNER_USERS
    ? USERS_ACCOUNT_TYPE_PARTNER_USERS_LIST
    : []
